import { TradeSectionHeading } from "@/components/trade/TradeSectionHeading";
import { CrewLineup } from "./CrewLineup";
import { WorldDoors } from "./WorldDoors";
import { SK_WORLDS, type WorldsContent } from "./worldsContent";

/** Home page block under the hero: the crew, then the two doors. */
export function WhoAreYouSection({ content = SK_WORLDS }: { content?: WorldsContent }) {
  return (
    <>
      <section className="hero-gradient overflow-hidden px-4 pb-8 pt-12 sm:px-6 sm:pt-16 lg:px-8">
        <div className="container-custom">
          <div className="space-y-3 text-center">
            <h2 className="text-3xl font-bold leading-tight text-foreground sm:text-4xl lg:text-5xl">{content.ui.heading}</h2>
            <p className="mx-auto max-w-2xl text-lg text-muted-foreground sm:text-xl">{content.ui.subheading}</p>
          </div>
          <CrewLineup mode="mix" content={content} />
        </div>
      </section>
      <section className="section-padding bg-background">
        <div className="container-custom max-w-6xl">
          <TradeSectionHeading
            badge={content.ui.doorsBadge}
            title={content.ui.doorsTitle}
            intro={content.ui.doorsIntro}
          />
          <WorldDoors content={content} />
        </div>
      </section>
    </>
  );
}
